export default "__VITE_ASSET__DKVqqu94__"